/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/no-unknown-property */
import React from 'react'

import LargeKPI from './large-kpi'
import MediumKPI from './medium-kpi'

interface Props {
  bgcNums
  mainKPI
  mediumKPIData
  setKpiName
  updateKpiFilter
}
const MediumContainerKPI = ({
  bgcNums,
  mainKPI,
  mediumKPIData,
  setKpiName,
  updateKpiFilter
}: Props) => {
  const mediumKPIs = mediumKPIData?.map((kpi: any, key) => (
    <MediumKPI
      bgcNum={bgcNums[key]}
      key={key}
      kpi={kpi}
      parentKPI={mainKPI.title}
      setKpiName={setKpiName}
      updateKpiFilter={updateKpiFilter}
    />
  ))

  return (
    <div className='col-12 px-2 mb-2 my-2 '>
      <div className='col col-md-12 align-items-stretch px-0 d-flex mt-0'>
        <div className='bordered2 border-radius w-100 p-0 '>
          <LargeKPI kpi={mainKPI} setKpiName={setKpiName} updateKpiFilter={updateKpiFilter} />
          <div className='col col-md-12 align-items-center d-flex'>
            <div className='border-top2 w-100 px-2'>{mediumKPIs}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default MediumContainerKPI
